import styled from '@emotion/styled';
import { theme } from '../../../theme';
/**
 * A small pip showing a number of unread notifications
 * associated with a navigation item. Should show
 * a maximum of 2 characters (i.e. "1", ... "8", "9+")
 */
export const Unread = styled.span `
	display: inline-flex;
	justify-content: center;
	align-items: center;
	background: ${theme.colors.NE100};
	color: ${theme.colors.LM_NU0};
	border-radius: 50%;
	${theme.typography.IB70}
	line-height: ${theme.typography.lineHeight.sm};
	width: 18px;
	height: 18px;
`;
//# sourceMappingURL=Unread.styled.js.map